import { render, staticRenderFns } from "./PermissionGroupsCard.vue?vue&type=template&id=39a71e90&"
import script from "./PermissionGroupsCard.vue?vue&type=script&lang=js&"
export * from "./PermissionGroupsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports